import { useEffect } from 'react';

export const useSyncCustomActionTypes = ({ allActionTypeTemplates, values, setValues }) => {
  useEffect(() => {
    const enabledCustoms = allActionTypeTemplates.reduce((accum, aTT) => {
      if (values[`customActionTypesEnabled#${aTT.id}`]) {
        return [...accum, aTT.id];
      }
      return accum;
    }, []);

    if (enabledCustoms.length !== values.customActionTypesEnabled.length) {
      setValues({ ...values, customActionTypesEnabled: enabledCustoms });
    }
  }, [allActionTypeTemplates, values, setValues]);
};
